import axios, { AxiosInstance } from 'axios';
import { Storage } from '@ionic/storage';
import { createStore } from '../ionic-storage';

export const authenticatedFetch = async (
  storage: Storage | null | undefined
): Promise<AxiosInstance> => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.response.status === 401) {
        const _storage = await createStore();
        _storage.clear();
        window.location.href = '/auth/sign-in';
      }
      return error;
    }
  );

  const token = await storage?.get('token');

  if (token) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    instance.defaults.headers.common['Authorization'] = ``;
  }
  return instance;
};
